import * as garagesConstants from '@store/garages/constants';

export const garagesGet = (payload) => ({ type: garagesConstants.GARAGES_GET_REQUEST, payload });
export const garagesGetSuccess = (payload) => ({ type: garagesConstants.GARAGES_GET_SUCCESS, payload });
export const garagesGetFail = (error) => ({ type:garagesConstants.GARAGES_GET_FAIL, error });
